import { Component } from '@angular/core';

@Component({
  selector: 'app-donut-widget-skeleton',
  templateUrl: './donut-widget-skeleton.component.html',
  styleUrls: ['./donut-widget-skeleton.component.scss'],
  standalone: false,
})
export class DonutWidgetSkeletonComponent {}
